import { useContext } from 'react'
import { ReactPressContext } from '../context/ReactPress'
import type WPAPI from 'wpapi'

const useReactPressContext = (): { wpapi: WPAPI; reactPress: IReactpress } => {
  const context = useContext(ReactPressContext)
  if (context === undefined) throw new Error('useReactPressContext must be used within a ReactPressProvider')
  return context
}

export default useReactPressContext
